import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=d3b3f722&scoped=true&"
import script from "./Fab.vue?vue&type=script&lang=js&"
export * from "./Fab.vue?vue&type=script&lang=js&"
import style0 from "./Fab.vue?vue&type=style&index=0&id=d3b3f722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b3f722",
  null
  
)

export default component.exports